<div class="contenedorDetalle">
  <div class="detalleHeader">
    <h2>
      Detalle Usuario ID
      {{ user?.id }}
    </h2>
  </div>
   <h3>Datos Usuario</h3>
   <div class="displayFlexJustify">
    <div class="displayFlexColumn">
      <div class="userdatos">
        <div class="usertitulo">
          Nombre
        </div>
        <div *ngIf="user.name" class="userinfo">
          {{user.name}}
        </div>
        <div *ngIf="!user.name" class="userinfo">
          Falta completar datos
        </div>
      </div>
      <div class="userdatos">
        <div class="usertitulo">
          Mail
        </div>
        <div class="userinfo">
          {{user.email}}
        </div>
      </div>
    </div>
    <div class="displayFlexColumn">
      <div class="userdatos">
        <div class="usertitulo">
          Usuario
        </div>
        <div class="userinfo">
          {{user.username}}
        </div>
      </div>
      <div *ngIf="user.contratista" class="userdatos">
        <div class="usertitulo">
          Contratista
        </div>
        <div *ngIf="user.contratista.nombreComercial" class="userinfo">
          {{user.contratista.nombreComercial}}
        </div>
        <div *ngIf="!user.contratista.nombreComercial" class="userinfo">
          Falta completar datos
        </div>
      </div>
      <div *ngIf="user.cliente" class="userdatos">
        <div class="usertitulo">
          Cliente
        </div>
        <div *ngIf="user.cliente.nombreComercial"class="userinfo">
          {{user.cliente.nombreComercial}}
        </div>
        <div *ngIf="!user.cliente.nombreComercial" class="userinfo">
          Falta completar datos
        </div>
      </div>
      <div *ngIf="user.inproeco == true" class="userdatos">
        <div class="usertitulo">
          Inproeco
        </div>
      </div>
    </div>
  </div>





    <!-- Detalle usuario con Edicion, pero ya no se va a usar -->
     <!-- <div class="displayFlex botonesDetalle">
      <div *ngIf="path !== '/cliente/estado/contratistas'">
        <button (click)="disableInput()">Editar</button>
      </div>
      <button class="button__secondary">Imprimir</button>
      <button class="button__secondary">Descarga</button>
    </div> 
  </div> -->
  <!-- <div>
    <form novalidate [formGroup]="detalleUsuario" class="detalleContenido">
      <div>
        <h3>Datos Usuario</h3>
        <div class="datos__detalle">
          <div>
            <label for="name">Nombre</label>
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="name"
              id="name"
            />
          </div>
          <div>
            <label for="usuario">Usuario</label>
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="username"
              id="username"
            />
          </div>
          <div>
            <label for="cif">Mail</label>
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="email"
              id="email"
            />
          </div>
        </div>
        <div *ngIf="!disableInputBox">
          <button (click)="updateUsuarioById()">Guardar</button>
        </div>
      </div>
    </form>
     <a [routerLink]="['inproeco/usuarios']" [mat-dialog-close]>
      Ir a tabla Usuarios
    </a>
  </div> -->
</div>
